import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@web/App";
import "@web/i18n";
import { initLanguage } from "@web/i18n/language";
import "@web/index.css";
import { registerServiceWorker } from "@web/shared/lib/service-worker";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container #root is missing from index.html");
}

void initLanguage().then(() =>
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  ),
);

registerServiceWorker();
